module.exports = __webpack_public_path__ + "static/media/stock_supervision_system.3f5ab4fd.png";